import { useSWRConfig } from "swr";
import { getUserToken } from "src/utils/jwtToken";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { errorHandler } from "src/hooks/errorHandler";

export function useUpdateWebinarPromotionRoutingLogicUser() {
  const accessToken = getUserToken();
  const { mutate, cache } = useSWRConfig();

  const service = useUserService();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  return (
    templateId: string | number,
    userId: string | number,
    body: { enabled: boolean },
  ) =>
    service
      .patch(
        `/api/webinars/template/${templateId}/promotion-routing-logic/${userId}`,
      )
      .set(headers)
      .send(body)
      .then(tokenRefreshHandler)
      .then((res: Response) => {
        // @ts-ignore
        const keys = cache.keys();

        // Invalidate webinar promotion routing logic queries and force refresh.
        Array.from(keys)
          .filter((r: any) =>
            r.includes(
              `/api/webinars/template/${templateId}/promotion-routing-logic`,
            ),
          )
          .forEach((k: any) => {
            mutate(k);
          });

        return res;
      })
      .then((res: Response) => res.body)
      .catch(errorHandler);
}
